import { apiClient } from "./ApiClient";

const markAffiliateLinkEntry = async (email) => {
  const { data } = await apiClient.patch(`/affiliate/link/code/${encodeURIComponent(email)}`);
  return data;
};

const createAffiliation = async () => {
  const { data } = await apiClient.post(`/affiliate/`);
  return data;
};

const getAffiliation = async () => {
  const { data } = await apiClient.get(`/affiliate/`);
  return data;
};

const deleteAffiliation = async () => {
  const { data } = await apiClient.delete(`/affiliate/`);
  return data;
};

const getAffiliationStats = async (dateStart, dateEnd) => {
  const params = new URLSearchParams();
  if (dateStart) params.append("date_start_inclusive", dateStart);
  if (dateEnd) params.append("date_end_exclusive", dateEnd);

  const { data } = await apiClient.get(`/affiliate/stats?${params.toString()}`);
  return data;
};

const requestWalletPayout = async (walletId, amount, bankAccountNo) => {
  const { data } = await apiClient.post(
    "/wallet/payout/request",
    {},
    {
      params: {
        wallet_id: walletId,
        amount,
        bank_account_no: bankAccountNo,
      },
    },
  );
  return data;
};

const getWalletByUser = async () => {
  const { data } = await apiClient.get("/wallet/user", {
    params: {
      payout_allowed: true,
    },
  });
  return data[0] || null;
};

// const getAffiliationStats = async () => {
//   return {
//     "total": {
//       "total_users_registered": 45,
//       "total_amount": 50.12,
//       "total_provision": 10.2,
//       "total_link_entries": 92
//     }
//   }
// };

export default {
  markAffiliateLinkEntry,
  createAffiliation,
  getAffiliation,
  deleteAffiliation,
  getAffiliationStats,
  requestWalletPayout,
  getWalletByUser,
};
